import * as React from "react";
import classnames from "classnames";
import { useIntl } from "@grandvisionhq/state";
/* empty css                    */
import { getActiveBrandPromotion } from "../../../../utils/utils/get-active-brand-promotion.js";
const BRAND_PROMOTIONS_DEFAULT = [];
const BrandPromotion = ({
  brandPromotions = BRAND_PROMOTIONS_DEFAULT,
  brandName,
  isClickable,
  className,
  size = "small"
}) => {
  const { getFormattedLabel } = useIntl();
  const brand = getActiveBrandPromotion(brandName, brandPromotions);
  if (!brand) {
    return null;
  }
  const imageUrl = isClickable ? brand.clickableLogo : brand.logo;
  if (!imageUrl) {
    return null;
  }
  const labelOptions = {
    hideLabelKey: true,
    defaultValue: `${brandName} reseller`,
    labelData: { brand: brandName }
  };
  const imageAlt = isClickable ? getFormattedLabel("products.brand.promotionLogo.verify", labelOptions) : getFormattedLabel("products.brand.promotionLogo", labelOptions);
  const image = /* @__PURE__ */ React.createElement("img", { src: imageUrl, alt: imageAlt, loading: "lazy" });
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      className: classnames(`brand-promotion`, className, { [`brand-promotion--${size}`]: size })
    },
    brand?.url && isClickable ? /* @__PURE__ */ React.createElement("a", { href: brand.url, target: "_blank", rel: "noreferrer" }, image) : /* @__PURE__ */ React.createElement(React.Fragment, null, image)
  );
};
export {
  BrandPromotion
};
//# sourceMappingURL=BrandPromotion.js.map
